import React from 'react'
import Button from '../../components/Button';
import Container from '../../components/Container';
import Input from '../../components/Form/Input';
import TextArea from '../../components/Form/TextArea';
import useForm from '../../hooks/useForm';
import { api } from '../../services/api';
import {Form, Submit} from './styled';
import Alert from '../../components/Alert';

const Contact: React.FC = () => {
    const [error, setError] = React.useState('');
    const [success, setSuccess] = React.useState('');

    const name = useForm('nome_completo');
    const email = useForm('email');
    const subject = useForm('notEmpty');
    const message = useForm();

    async function submitForm(e: React.FormEvent) {
        e.preventDefault();

        if (email.validate()) {
            try{
                const {data} = await api.post('/contact', {
                    name: name.value,
                    email: email.value,
                    subject: subject.value,
                    message: message.value
                });

                setSuccess(data.message);

                name.setValue('');
                email.setValue('');
                subject.setValue('');
                message.setValue('');
            }catch(error){
                const result = (error as Error).message;
                setError(result);
            }
        }
    }

    const handleMessageSuccess = () => {
        setSuccess('');
    }

    const handleMessageError = () => {
        setError('');
    }

    return (
        <Container className="bg-branco">
            <h2>Entre em contato</h2>
            <p>Você também pode enviar um email diretamente para "sac@sultan.com.br"</p>
            <Form onSubmit={submitForm}>
                <Input label="Nome:" required placeholder="Digite seu Nome" autoComplete="off" id="name" type="text" {...name}/>
                <Input label="Seu E-mail:" required placeholder="Digite seu Email" autoComplete="off" id="email" type="text" {...email}/>
                <Input label="Assunto:" required placeholder="Exemplo: Dúvidas sobre Cadastro" autoComplete="off" id="subject" type="text" {...subject}/>
                <TextArea label="Mensagem:" maxLength={500} required placeholder="Sua mensagem (Máximo de 500 caracteres)" id="message" {...message}/>
                <Submit>
                    <Button type="submit">Enviar</Button>
                </Submit>
            </Form>
            <Alert open={success !== ''} onClose={handleMessageSuccess} severity="success" message={success}/>                                                                       
            <Alert open={error !== ''} onClose={handleMessageError} severity="error" message={error}/>          
        </Container>
    )
}

export default Contact;
